export const STORE_NAME = 'core/media-editor';
